import {Injectable, EventEmitter} from '@angular/core';
import {HttpClient,HttpResponse, HttpErrorResponse} from '@angular/common/http';
import {User} from '../../models/beans';
import {ItemsService} from 'app/commons/items.service';
import {Router} from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import {MessageService} from 'primeng/api';

@Injectable({
    providedIn: 'root'
})
export class LoginService {
    
    public loginEmetteur: EventEmitter<{}> = new EventEmitter();;
    
    private user : any;

    constructor(private http: HttpClient,private messageService: MessageService, private router: Router) {
        if(localStorage.getItem('currentUser') != null)
            this.user = JSON.parse(localStorage.getItem('currentUser'));
    }

    login(user: User) {
        this.http.post(ItemsService.API_URL+'auth/login', user, {observe: 'response'}).subscribe(
            (response: HttpResponse<User>) => {
                this.user = response.body;
                localStorage.setItem('currentUser', JSON.stringify(this.user));
                this.loginEmetteur.emit({});
                this.messageService.add({severity: 'success', summary: 'Utilisateur connecté', detail: 'Bienvenu ' + response.body.name});
                this.router.navigate(['/dashboard']);
            },
            (response: HttpErrorResponse) => {
                var detail = 'Login ou mot de passe incorrect';
                if (response.status == 550)
                    detail = 'Utilisateur désactivé';
                if (response.status == 551)
                    detail = "L'utilisateur n'est pas un admnistrateur";
                this.messageService.add({severity: 'error', summary: 'Erreur lors de la connexion', detail: detail});
                localStorage.removeItem("currentUser");
                this.loginEmetteur.emit({});
            });
    }
    logout() {
        this.user = null;
        localStorage.removeItem("currentUser");
        this.router.navigate(['/login']);
    }
    

    isLoggedIn() {
        return this.user != null && this.user.token != null;
    }

    isLoggedAdmin() {
        return this.user != null && this.user.token != null && ['ADMIN','BACKENDADMIN','SUPERADMIN'].includes(this.user.group);
    }
    
    isLoggedBackendAdmin() {
        return this.user != null && this.user.token != null && ['BACKENDADMIN','SUPERADMIN'].includes(this.user.group);
    }
    isLoggedSuperAdmin() {
        return this.user != null && this.user.token != null && this.user.group == 'SUPERADMIN';
    }

    getLoggedUser() {
        return this.user;
    }
}
